// Recovered compiled webpack factory 81611. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { Z: () => i });
  var n = r(2257),
    a = r(43275),
    o = r(87624);
  function i(e, t) {
    let r = (0, n.KU)(),
      i = (0, n.rm)();
    if (!r) return;
    let { beforeBreadcrumb: s = null, maxBreadcrumbs: l = 100 } = r.getOptions();
    if (l <= 0) return;
    let u = { timestamp: (0, o.lu)(), ...e },
      c = s ? (0, a.pq)(() => s(u, t)) : u;
    null !== c && (r.emit && r.emit("beforeAddBreadcrumb", c, t), i.addBreadcrumb(c, l));
  }
}
